import React, { createContext, useContext } from 'react';
import { HotLeadListState, useHotLeadList } from '../components/HotLeadList/useHotLeadList';
const HotLeadContext = createContext<HotLeadListState | null>(null);
interface HotLeadProviderProps {
  children: React.ReactNode;
}

/**
 * Shares one hot lead queue between the utility bar popup and the full page,
 * so agreeing in one surface updates the other.
 */
export function HotLeadProvider({
  children
}: HotLeadProviderProps) {
  const value = useHotLeadList();
  return <HotLeadContext.Provider value={value} data-id="element-184" data-mp="4burksa9ybeh">{children}</HotLeadContext.Provider>;
}
export function useHotLeads(): HotLeadListState {
  const context = useContext(HotLeadContext);
  if (!context) {
    throw new Error('useHotLeads must be used inside a HotLeadProvider');
  }
  return context;
}